import { createAction, props } from '@ngrx/store';
import { AppNotificationInterface } from '../models/app-notification.interface';

export enum ActionTypes {
  PushAppNotification = '[Core] Push App Notification',
  DismissAppNotification = '[Core] Dismiss App Notification',
  DismissAppNotificationsWithTopic = '[Core] Dismiss App Notifications With Topic',
}

export const pushAppNotification = createAction(
  ActionTypes.PushAppNotification,
  props<{ notification: AppNotificationInterface }>(),
);
export const dismissAppNotification = createAction(
  ActionTypes.DismissAppNotification,
  props<{ id: string }>(),
);
export const dismissAppNotificationsWithTopic = createAction(
  ActionTypes.DismissAppNotificationsWithTopic,
  props<{ topic: string }>(),
);
